import(/* webpackMode: "eager" */ "/vercel/path0/components/i18n/lang-context-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JBDAAboutUs"] */ "/vercel/path0/components/jbda/jbda/jbda-aboutUs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JBDAPromiseBG"] */ "/vercel/path0/components/jbda/jbda/jbda-promise-bg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LBAction"] */ "/vercel/path0/components/jbda/lb/lb-action.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LBPromiseBG"] */ "/vercel/path0/components/jbda/lb/lb-promise-bg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Section"] */ "/vercel/path0/components/jbda/section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/markdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
